const fragment = `
  id
  price
  optionType {
    id
    name
    imageUrl
  }
`;

export const listOptionsQuery = `
  query ListOptions(
    $filter: OptionFilterInput
  ) {
    items: listOptions(filter: $filter) {
      ${fragment}
    }
  }
`;

export const getOptionQuery = `
  query GetOption($id: Int!) {
    item: getOption(id: $id) {
      ${fragment}
    }
  }
`;

export const createOptionQuery = `
  mutation CreateOption(
    $input: CreateOptionInput!
  ) {
    item: createOption(input: $input) {
      ${fragment}
    }
  }
`;

export const updateOptionQuery = `
  mutation updateOption(
    $input: UpdateOptionInput!
  ) {
    item: updateOption(input: $input) {
      ${fragment}
    }
  }
`;

export const deleteOptionQuery = `
  mutation DeleteOption(
    $id: Int!
  ) {
    item: deleteOption(id: $id) {
      ${fragment}
    }
  }
`;
